import React, { FC, useContext } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import {
  Context,
  careerSheetPath,
  careerMapPath,
} from "../../../store/student";
import { ALERTS } from "../../../constants/career";

import styles from "./MapActionButtons.module.scss";

type Props = {
  isShowAlert?: boolean;
  createCareerSheets: () => void;
};

const MapActionButtons: FC<Props> = ({
  isShowAlert = true,
  createCareerSheets,
}) => {
  const { contextState } = useContext(Context);
  const history = useHistory();

  const feedbackQuestions = contextState.career_feedback_questions;
  const latestSheet = contextState.career_latest_sheet;
  const latestFeedbackSheet = contextState.career_latest_feedback_sheet;
  const feedBackSheets = contextState.career_feedback_sheets;

  const isQuestionsCompleted = feedbackQuestions.every(
    question => question.realization !== null,
  );

  const isSheetActive =
    !latestSheet ||
    latestSheet.completed_at === null ||
    (feedbackQuestions.length !== 0 && isQuestionsCompleted);

  const isMapActive = feedBackSheets.length > 0;

  const isGeneratingMap =
    latestSheet !== null &&
    latestSheet.completed_at !== null &&
    latestFeedbackSheet === null;

  const isGeneratingQuestions =
    latestFeedbackSheet?.read_at && feedbackQuestions.length === 0;

  const isQuestionsIncomplete = !isQuestionsCompleted;

  const hasUnreadGeneratedMap =
    latestFeedbackSheet !== null && latestFeedbackSheet.read_at === null;

  return (
    <div className={styles.wrapper}>
      {isShowAlert && (
        <>
          {isGeneratingMap && (
            <p className={clsx(styles.alert, styles.isActive)}>
              {ALERTS.GENERATING_MAP}
            </p>
          )}
          {hasUnreadGeneratedMap && (
            <p className={clsx(styles.alert, styles.isActive)}>
              {ALERTS.NEW_MAP_AVAILABLE}
            </p>
          )}
          {isGeneratingQuestions && (
            <p className={clsx(styles.alert, styles.isActive)}>
              {ALERTS.GENERATING_QUESTIONS}
            </p>
          )}
          {isQuestionsIncomplete && (
            <p className={clsx(styles.alert, styles.isActive)}>
              {ALERTS.INCOMPLETE_QUESTIONS}
            </p>
          )}
        </>
      )}
      <button
        className={clsx(styles.button, styles.sheet)}
        disabled={!isSheetActive}
        onClick={() => {
          createCareerSheets();
          history.push(careerSheetPath);
        }}
      >
        キャリア開拓シートを記入する
      </button>
      <button
        className={clsx(styles.button, styles.map)}
        disabled={!isMapActive}
        onClick={() => history.push(careerMapPath)}
      >
        キャリア開拓MAPを見る
      </button>
    </div>
  );
};

export default MapActionButtons;
